export default from './no-search-results';



// WEBPACK FOOTER //
// ./app/components/no-search-results/index.js